import { createToastService } from './ToastService.impl';

export const myToastService = createToastService();
